import type { CardHooks } from "./registry";

/**
 * Doubled Block — Utility / Maneuver.
 *
 * Supabase row: `cardType: "Utility"`, `utilityType: "Maneuver"`, ability:
 *   "You may play 2 Defend cards against an incoming attack. Add their
 *    block values together."
 *
 * Flow:
 *  1. Played as a Utility/Maneuver during the defend window (i.e. when an
 *     unresolved opposing attack is in the combat stack).
 *  2. `onUtilityPlay` returns `openDoubleDefendWindow: true`. The engine
 *     finds the most recent unresolved attack against the actor and sets
 *     `doubleDefendPendingSlotId` + `doubleDefendPlayerNum` on GameState.
 *  3. The player now plays TWO defend cards. The first attaches via the
 *     normal `attachBlock` / `playAttackDefend` path. The second is routed
 *     through `attachDoubleDefend`, which stores it on the slot's
 *     `doubleDefendCard` field.
 *  4. In `resolveCombat`, the slot's `doubleDefendCard` block value is added
 *     to `blockCard`'s block value (already wired by the subagent).
 *
 * Note on UI:
 *  The UI must read `gs.doubleDefendPendingSlotId` and, when the active
 *  player has it, route their next defend through `attachDoubleDefend`
 *  instead of `playAttackDefend`. That wiring lives in PlaytestBoard's
 *  defend-play handler and is tracked as a TODO in phase3-progress.md.
 *
 * Engine integration note:
 *  The engine's existing `openDoubleDefendWindow` handling lives in the
 *  `onDefendPlay` path (it reads `_targetSlot` from that path's local
 *  context). For utility play we need a parallel handler that finds the
 *  most-recent unresolved opposing attack slot and sets the same
 *  GameState fields. That parallel handler is added in this commit at the
 *  end of `playUtility` (look for the Doubled Block branch).
 */
export const doubledBlock: CardHooks = {
  onUtilityPlay: (_ctx) => ({
    openDoubleDefendWindow: true,
    log: [
      "Doubled Block — you may play one additional defend against this attack (block values sum).",
    ],
  }),
};
